<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容：">
              <Input search enter-button placeholder="请输入姓名/联系电话搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选性别：">
              <Select v-model="filter.gender" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">男</Option>
                <Option :value="2">女</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选圈舍：">
              <Select v-model="filter.pig_house_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigHouseList" :key="key" :value="key" >{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
          <Col style="margin-left: 20px">
            <Button type="primary" icon="ios-cloud-download-outline" @click="exportTableData" :loading="exportLoading">报告导出</Button>
          </Col>
          <Col style="margin-left: 20px">
            <Button type="primary" @click="shiftScheduling">人员排班</Button>
          </Col>
        </Row>
        <Row type="flex" style="flex-wrap: nowrap;margin: 20px 20px 0 20px">

          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加</Button>
          </Col>

          <Col style="display: flex;flex-wrap: nowrap; justify-content: space-between;margin-left: 20px;">
            <ImportExcel
              ref="importExcel"
              :importMethod="importData"
              @importMethod="importData"
            />

            <Button style="margin-left: 20px;" type="primary" icon="ios-cloud-download-outline" @click="importData({template: 1})">模版</Button>
          </Col>

        </Row>
      </Form>

      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="info(row.pig_user_id)">查看</a>
          <Divider type="vertical" />
          <a @click="edit(row.pig_user_id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row.pig_user_id)">删除</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import { pigUserListApi, pigUserDelApi, pigUserImportApi } from '@/api/pigFarm/pigUser'
import {pigHouseAllApi} from "@/api/pigFarm/pigHouse";
import {cattleDutyDetailApi} from "@/api/cattleFarm/cattleDuty";
import ImportExcel from "_c/importExcel/ImportExcel";


export default {
  name: 'pigUserList',
  inject: ['reload'],
  components: {
    ImportExcel
  },
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
        export: 0,
        search: '',
        gender: 0,
        pig_house_id: 0,
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      exportLoading: false,
      pigHouseList: [],
      columns: [
        {
          title: '负责圈舍',
          key: 'pig_house_name',
          minWidth: 120
        },
        {
          title: '姓名',
          key: 'real_name',
          minWidth: 100
        },
        {
          title: '联系电话',
          key: 'phone',
          minWidth: 120
        },
        {
          title: '性别',
          key: 'gender_msg',
          minWidth: 100
        },
        {
          title: '岗位',
          key: 'job',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }

      ]
    }
  },
  created () {
    this.loadPigHouseData()
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      this.filter.export = 0
      pigUserListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear () {
        this.filter.search = ''
        this.loadTableData()
    },
    // 下拉选择
    select(value){
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },
    // 数据导出
    exportTableData () {
      this.exportLoading = true
      this.filter.export = 1
      pigUserListApi(this.filter).then(res => {
        this.exportLoading = false
        if(res.code === 200){
          if (res.data.url){
            window.open(res.data.url)
          }else{
            this.$Message.error('导出失败')
          }
        }else{
          this.exportLoading = false
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.exportLoading = false
        this.$Message.error(res.msg)
      })
    },
    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },
    // 编辑
    edit (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'edit', id) })
    },
    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除？',
        onOk: () => {
          pigUserDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 人员排班
    shiftScheduling () {
      // 调用接口获取人员排班图片
      cattleDutyDetailApi(1).then(res => {
        //数据赋值
        let cattleDutyUrl = res.data.duty_pic

        // 弹框展示图片 并且增加修改按钮跳转到人员排班页面
        this.$Modal.confirm({
          title: '人员排班',
          width: 40,
          closable: true,
          okText: '修改',
          cancelText: '关闭',
          content: `<div style="padding: 20px;"><img src="${cattleDutyUrl}" style="width: 100%;height: 100%;"></div>`,
          onOk: () => {
            this.$router.push({ path: '/admin/digitalLivestock/pigFarm/base/pigDuty/edit' })
          },

        })
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 加载圈舍数据
    loadPigHouseData() {
      pigHouseAllApi().then(res => {
        if (res.code === 200) {
          this.pigHouseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error()
      })
    },

    // 数据导入
    importData(params = {file_url: '', preview: 0, template: 0}) {

      pigUserImportApi(params).then(res => {
        if (res.code === 200) {
          // 下载模版
          if(params.template){
            window.open(res.data)
            return
          }

          // 预览
          if(params.preview){
            const header = res.data.header
            const data = res.data.data
            // 调用子组件自定义事件把header和data设置到子组件中
            this.$refs.importExcel.receiveProcessedData({ header, data })
            return
          }

          // 导入
          this.$Message.success(res.data);

          this.loadTableData()

        } else {
          this.$Message.error(res.msg);
        }
      }).catch(res => {
        this.$Message.error(res.msg);
      })
    },

  }
}
</script>
